import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { ChevronLeft } from "../../assets/svgs";
import { getSvgComponent } from "../../utils/svgUtils";
import useApp from "../../hooks/useApp";
import "./styles.scss";

const StepHeader = ({
  stepperIcon,
  currentStep,
  totalSteps,
  title,
  onClick,
  backEnable = false,
  hideBackButton = false,
  showBar,
  showLogo,
}) => {
  const { isRTL, tenantConfig } = useApp();
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];
  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className="step-progress-container">
      {!showBar && (
        <div className="step-header">
          {backEnable && !hideBackButton ? (
            <img
              src={ChevronLeft}
              alt="left-arrow"
              className={isRTL ? "left-arrow-rtl" : "left-arrow"}
              onClick={onClick}
            />
          ) : null}
          <div className="circle">
            <img src={getSvgComponent(stepperIcon)} alt={stepperIcon} />
          </div>
          <div className={isRTL ? "step-info-rtl" : "step-info"}>
            <span className="step-number">{`${t(
              `global.step`
            )} ${currentStep}/${totalSteps}`}</span>
            <h2 className={`step-title ${isRTL ? "step-title-rtl" : ""}`}>
              {t(`${routeName}.${title}`, { tenant: tenantConfig?.name })}
            </h2>
          </div>
        </div>
      )}
      <div className={showLogo ? "progress-logo-bar" : "progress-bar"}>
        <div
          className="progress"
          style={{ width: showBar ? "100%" : `${[progressPercentage]}%` }}
        ></div>
      </div>
      {showLogo && (
        <img
          src={`${tenantConfig?.logo.content.default}`}
          alt="logo"
          className="logo"
        />
      )}
    </div>
  );
};

export default StepHeader;
